// Brand Quiz Mock Data

export const quizQuestions = [
  {
    id: 1,
    question: "What's your current business stage?",
    subtitle: "Help us understand where you are in your journey",
    options: [
      {
        id: 'a',
        text: "Just an idea - haven't launched yet",
        value: 'startup',
        icon: 'Lightbulb'
      },
      {
        id: 'b',
        text: "Launched within the last year",
        value: 'early',
        icon: 'Rocket'
      },
      {
        id: 'c',
        text: "Established business (1-5 years)",
        value: 'growing',
        icon: 'TrendingUp'
      },
      {
        id: 'd',
        text: "Mature company (5+ years)",
        value: 'established',
        icon: 'Building'
      }
    ]
  },
  {
    id: 2,
    question: "What's your primary branding goal?",
    subtitle: "Choose what matters most right now",
    options: [
      {
        id: 'a',
        text: "Create brand identity from scratch",
        value: 'identity',
        icon: 'Palette'
      },
      {
        id: 'b',
        text: "Refresh/rebrand existing business",
        value: 'rebrand',
        icon: 'RefreshCw'
      },
      {
        id: 'c',
        text: "Launch new website or online presence",
        value: 'digital',
        icon: 'Globe'
      },
      {
        id: 'd',
        text: "Scale marketing and expand reach",
        value: 'marketing',
        icon: 'Megaphone'
      }
    ]
  },
  {
    id: 3,
    question: "Which services interest you most?",
    subtitle: "Select your top priority",
    options: [
      {
        id: 'a',
        text: "Professional Logos & Brand Development",
        value: 'logo',
        icon: 'Palette'
      },
      {
        id: 'b',
        text: "Website Design & Landing Pages",
        value: 'website',
        icon: 'Monitor'
      },
      {
        id: 'c',
        text: "Digital Marketing & Content Creation",
        value: 'marketing',
        icon: 'BarChart'
      },
      {
        id: 'd',
        text: "Business Consulting & Automation",
        value: 'consulting',
        icon: 'Zap'
      }
    ]
  },
  {
    id: 4,
    question: "What's your timeline?",
    subtitle: "When do you need to launch?",
    options: [
      {
        id: 'a',
        text: "ASAP - within 2 weeks",
        value: 'urgent',
        icon: 'Clock'
      },
      {
        id: 'b',
        text: "1-2 months",
        value: 'normal',
        icon: 'Calendar'
      },
      {
        id: 'c',
        text: "3-6 months",
        value: 'planned',
        icon: 'CalendarRange'
      },
      {
        id: 'd',
        text: "Just exploring options",
        value: 'exploring',
        icon: 'Search'
      }
    ]
  },
  {
    id: 5,
    question: "What's your investment range?",
    subtitle: "Choose what aligns with your budget",
    options: [
      {
        id: 'a',
        text: "Starter - $2K-$5K",
        value: 'starter',
        icon: 'DollarSign'
      },
      {
        id: 'b',
        text: "Professional - $5K-$15K",
        value: 'professional',
        icon: 'Banknote'
      },
      {
        id: 'c',
        text: "Premium - $15K-$50K",
        value: 'premium',
        icon: 'Gem'
      },
      {
        id: 'd',
        text: "Enterprise - $50K+",
        value: 'enterprise',
        icon: 'Crown'
      }
    ]
  },
  {
    id: 6,
    question: "What's driving this decision?",
    subtitle: "Your main motivation",
    options: [
      {
        id: 'a',
        text: "Need to stand out from competitors",
        value: 'competitive',
        icon: 'Target'
      },
      {
        id: 'b',
        text: "Attract better clients/customers",
        value: 'growth',
        icon: 'Users'
      },
      {
        id: 'c',
        text: "Prepare for major expansion",
        value: 'expansion',
        icon: 'TrendingUp'
      },
      {
        id: 'd',
        text: "Current brand doesn't reflect quality",
        value: 'quality',
        icon: 'Award'
      }
    ]
  }
];

// Quiz Result Templates
export const quizResults = {
  startup_identity: {
    title: "Brand Foundation Builder",
    subtitle: "Perfect for launching your vision",
    description: "You're at the exciting stage of bringing your idea to life. You need a strong brand foundation that positions you as a serious player from day one.",
    recommendedServices: [
      "New Business Consultations",
      "Professional Logos",
      "Brand Development"
    ],
    investment: "$5K-$15K",
    timeline: "4-6 weeks",
    nextStep: "Book a free brand strategy session"
  },
  early_digital: {
    title: "Digital Accelerator",
    subtitle: "Take your online presence to the next level",
    description: "You've launched, now it's time to scale. You need a powerful digital presence that converts visitors into customers and builds credibility.",
    recommendedServices: [
      "Landing Pages",
      "Complete Website Design & Launch",
      "Digital Marketing & Ads"
    ],
    investment: "$8K-$25K",
    timeline: "6-8 weeks",
    nextStep: "Get your custom growth roadmap"
  },
  growing_rebrand: {
    title: "Evolution Package",
    subtitle: "Elevate your brand to match your growth",
    description: "Your business has evolved, but your brand hasn't kept pace. It's time for a refresh that reflects your current position and future ambitions.",
    recommendedServices: [
      "Brand Development",
      "Content & Media Creation",
      "Publishing/Printings"
    ],
    investment: "$15K-$40K",
    timeline: "8-12 weeks",
    nextStep: "Schedule your rebrand consultation"
  },
  established_complete: {
    title: "Market Domination Suite",
    subtitle: "Own your industry",
    description: "You're ready to dominate. You need a complete brand ecosystem that establishes you as the undisputed leader in your market.",
    recommendedServices: [
      "Business Growth Consulting",
      "Automation & Systems",
      "Digital Marketing & Ads",
      "Content & Media Creation"
    ],
    investment: "$30K-$100K+",
    timeline: "12-16 weeks",
    nextStep: "Begin your transformation"
  },
  marketing_focused: {
    title: "Growth Catalyst",
    subtitle: "Drive measurable results",
    description: "You have a solid brand, now you need to amplify it. Our marketing packages will multiply your reach and drive consistent lead generation.",
    recommendedServices: [
      "Digital Marketing & Ads",
      "Content & Media Creation",
      "Landing Pages"
    ],
    investment: "$10K-$35K",
    timeline: "6-10 weeks",
    nextStep: "Get your marketing blueprint"
  },
  consulting_focused: {
    title: "Strategic Growth Partner",
    subtitle: "Scale with expert guidance",
    description: "You need strategic expertise and systems to reach the next level. We'll help you optimize operations and accelerate sustainable growth.",
    recommendedServices: [
      "Business Growth Consulting",
      "Automation & Systems",
      "Digital Marketing & Ads"
    ],
    investment: "$12K-$40K",
    timeline: "8-12 weeks",
    nextStep: "Schedule your strategy session"
  },
  default: {
    title: "Custom Brand Solution",
    subtitle: "Tailored to your unique needs",
    description: "Every business is unique. Based on your responses, we'll craft a custom package that aligns perfectly with your goals, timeline, and investment range.",
    recommendedServices: [
      "New Business Consultations",
      "Custom Package Design",
      "Flexible Solutions"
    ],
    investment: "Custom Quote",
    timeline: "Flexible",
    nextStep: "Discuss your custom solution"
  }
};

// Quiz scoring logic
export const calculateQuizResult = (answers) => {
  const stage = answers[1] || 'startup';
  const goal = answers[2] || 'identity';
  const service = answers[3] || 'logo';
  const budget = answers[5] || 'starter';

  // Determine result based on answer combinations
  if (stage === 'startup' && (goal === 'identity' || service === 'logo')) {
    return 'startup_identity';
  } else if ((stage === 'early' || stage === 'startup') && (goal === 'digital' || service === 'website')) {
    return 'early_digital';
  } else if ((stage === 'growing' || stage === 'established') && goal === 'rebrand') {
    return 'growing_rebrand';
  } else if (stage === 'established' && (service === 'consulting' || budget === 'enterprise')) {
    return 'established_complete';
  } else if (goal === 'marketing' || service === 'marketing') {
    return 'marketing_focused';
  } else if (service === 'consulting') {
    return 'consulting_focused';
  } else {
    return 'default';
  }
};


// ─────────────────────────────────────────────────────────────────────────────
// A/B Test — Quiz Variants
// Variant A (control): direct / functional copy (the `quizQuestions` export above)
// Variant B (challenger): aspirational / emotional reframing. Same 6 questions,
// same answer `value`s → scoring in `calculateQuizResult` works for both.
// Only the on-screen wording differs — this isolates the effect of tone/copy
// on completion rate and conversion.
// ─────────────────────────────────────────────────────────────────────────────

export const quizQuestionsVariantB = [
  {
    id: 1,
    question: "Where are you in your brand's journey?",
    subtitle: "Every great brand starts somewhere — pick your chapter",
    options: [
      { id: 'a', text: "I have a vision, but haven't launched yet",        value: 'startup',     icon: 'Lightbulb' },
      { id: 'b', text: "I've launched — still finding my footing",         value: 'early',       icon: 'Rocket' },
      { id: 'c', text: "I'm growing — and ready for the next leap",        value: 'growing',     icon: 'TrendingUp' },
      { id: 'd', text: "I'm established — and it's time to evolve",        value: 'established', icon: 'Building' }
    ]
  },
  {
    id: 2,
    question: "What does a win look like for your brand?",
    subtitle: "Pick the outcome that would matter most right now",
    options: [
      { id: 'a', text: "A brand identity that feels unmistakably me",      value: 'identity',  icon: 'Palette' },
      { id: 'b', text: "A fresh look that finally matches who we've become", value: 'rebrand', icon: 'RefreshCw' },
      { id: 'c', text: "A digital presence that actually converts",         value: 'digital',   icon: 'Globe' },
      { id: 'd', text: "Marketing momentum that keeps the pipeline full",   value: 'marketing', icon: 'Megaphone' }
    ]
  },
  {
    id: 3,
    question: "Which craft are you most drawn to?",
    subtitle: "The work that'll move the needle first",
    options: [
      { id: 'a', text: "A logo + identity system people remember",          value: 'logo',       icon: 'Palette' },
      { id: 'b', text: "A website that tells the story perfectly",          value: 'website',    icon: 'Monitor' },
      { id: 'c', text: "Content + marketing that makes us impossible to ignore", value: 'marketing', icon: 'BarChart' },
      { id: 'd', text: "Systems + consulting so the business runs smoother",value: 'consulting', icon: 'Zap' }
    ]
  },
  {
    id: 4,
    question: "How soon do you want this live?",
    subtitle: "Be honest — urgency shapes the approach",
    options: [
      { id: 'a', text: "Yesterday — it's time-sensitive",                  value: 'urgent',    icon: 'Clock' },
      { id: 'b', text: "Next month or two",                                value: 'normal',    icon: 'Calendar' },
      { id: 'c', text: "This quarter — room to get it right",              value: 'planned',   icon: 'CalendarRange' },
      { id: 'd', text: "Still exploring — not locked in yet",              value: 'exploring', icon: 'Search' }
    ]
  },
  {
    id: 5,
    question: "What kind of investment feels right?",
    subtitle: "No judgment — just helps us shape the right proposal",
    options: [
      { id: 'a', text: "Starter kit · $2K–$5K",                            value: 'starter',      icon: 'DollarSign' },
      { id: 'b', text: "Professional · $5K–$15K",                          value: 'professional', icon: 'Banknote' },
      { id: 'c', text: "Premium · $15K–$50K",                              value: 'premium',      icon: 'Gem' },
      { id: 'd', text: "Enterprise · $50K+",                               value: 'enterprise',   icon: 'Crown' }
    ]
  },
  {
    id: 6,
    question: "What's really driving you right now?",
    subtitle: "The motivation behind the move",
    options: [
      { id: 'a', text: "We need to stand out — the market is noisy",       value: 'competitive', icon: 'Target' },
      { id: 'b', text: "We want to attract better customers",              value: 'growth',      icon: 'Users' },
      { id: 'c', text: "We're preparing for a major expansion",            value: 'expansion',   icon: 'TrendingUp' },
      { id: 'd', text: "We've earned it — it's time for a premium upgrade",value: 'premium_feel',icon: 'Award' }
    ]
  }
];

export const quizVariants = {
  A: quizQuestions,
  B: quizQuestionsVariantB,
};

// Sticky 50/50 assignment persisted in localStorage so a user sees the same
// variant across reloads (important for honest completion-rate measurement).
// First call assigns; subsequent calls return the stored value.
export const getAssignedVariant = () => {
  if (typeof window === 'undefined') return 'A';
  try {
    const existing = localStorage.getItem('icd_quiz_variant');
    if (existing === 'A' || existing === 'B') return existing;
    const v = Math.random() < 0.5 ? 'A' : 'B';
    localStorage.setItem('icd_quiz_variant', v);
    return v;
  } catch {
    return 'A';
  }
};
